import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=2a83dc34&scoped=true&lang=pug"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=2a83dc34&prod&lang=scss"
import style1 from "./Form.vue?vue&type=style&index=1&id=2a83dc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83dc34",
  null
  
)

export default component.exports